<app-bulk-asset-qr-details></app-bulk-asset-qr-details>
